





















































import type { AppliedLesson } from '@/models/appliedlesson';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import MoreInfoModal from '@/components/MoreInfoModal.vue';
import { toggleModal } from '@/helpers/modal';
import type { PMAppliedLesson } from '@/models/pmappliedlesson';
import type { XAppliedLesson } from '@/models/xappliedlesson';
import type { Project } from '@/models/project';
import FormProjectUserPicker from '@/components/form/FormProjectUserPicker.vue';
import FormDynamicFieldPicker from '@/components/form/FormDynamicFieldPicker.vue';
import type { CompanySetting } from '@/models/companySetting';
import type { User } from '@/models/user';
import type { AppliedLessonsFilter } from '@/helpers/AppliedLessonsFilter';

@Component({
    name: 'AppliedLessonContainerHeader',
    components: {
        MoreInfoModal,
        FormProjectUserPicker,
        FormDynamicFieldPicker,
    },
})
export default class AppliedLessonContainerHeader extends Vue {
    @Prop() private appliedlesson: AppliedLesson;
    @Prop() private parentIndex: number;
    @Prop() private even: number;
    @Prop() private tableColumns: AppliedLessonsFilter;

    @Getter('account/userInfo') private userInfo: User;
    private toggleModal = toggleModal;
    private tableUpdateKey = 0;
    @Getter('project/selectedProject') private selectedProject: Project;
    @Getter('account/companySetting') private companySetting: CompanySetting;

    update(lesson: AppliedLesson | PMAppliedLesson | XAppliedLesson) {
        // neutralize datepicker timezone
        if (lesson.contacttill) {
            lesson.contacttill.setMinutes(lesson.contacttill.getMinutes() - lesson.contacttill.getTimezoneOffset());
        }
        this.$emit('update', lesson);
        this.tableUpdateKey++;
    }
}
